var map = {
	"./rugby/argentina-logo-icon.png": "a3f3",
	"./rugby/australia-logo-icon.png": "9b99",
	"./rugby/benetton-rugby-logo-icon.png": "b9bc",
	"./rugby/blue-bulls-logo-icon.png": "b1c5",
	"./rugby/bulls-logo-icon.png": "9847",
	"./rugby/cardiff-rugby-logo-icon.png": "873f",
	"./rugby/chile-logo-icon.png": "1574",
	"./rugby/connacht-rugby-logo-icon.png": "1c8e",
	"./rugby/dragons-rfc-logo-icon.png": "995b",
	"./rugby/edinburgh-rugby-logo-icon.png": "cf8e",
	"./rugby/england-logo-icon.png": "a202",
	"./rugby/figi-logo-icon.png": "495f",
	"./rugby/fiji-logo-icon.png": "2341",
	"./rugby/france-logo-icon.png": "f337",
	"./rugby/free-state-cheetahs-logo-icon.png": "1e85",
	"./rugby/georgia-logo-icon.png": "5bd7",
	"./rugby/glasgow-warriors-logo-icon.png": "d21e",
	"./rugby/griffons-logo-icon.png": "7870",
	"./rugby/griquas-logo-icon.png": "3e91",
	"./rugby/ireland-logo-icon.png": "faa2",
	"./rugby/italy-logo-icon.png": "54e3",
	"./rugby/japan-logo-icon.png": "6ab2",
	"./rugby/leinster-rugby-logo-icon.png": "9289",
	"./rugby/lions-logo-icon.png": "8635",
	"./rugby/munster-rugby-logo-icon.png": "c62a",
	"./rugby/namibia-logo-icon.png": "c691",
	"./rugby/new-zealand-logo-icon.png": "c087",
	"./rugby/new-zealend-logo-icon.png": "ed3b",
	"./rugby/ospreys-logo-icon.png": "6612",
	"./rugby/portugal-logo-icon.png": "7bd5",
	"./rugby/pumas-logo-icon.png": "ca73",
	"./rugby/romania-logo-icon.png": "efb4",
	"./rugby/samoa-logo-icon.png": "4fd4",
	"./rugby/scarlets-logo-icon.png": "3078",
	"./rugby/scotland-logo-icon.png": "5fb7",
	"./rugby/sharks-logo-icon.png": "b21a",
	"./rugby/sharks-xv-logo-icon.png": "52de",
	"./rugby/sigma-lions-logo-icon.png": "1421",
	"./rugby/south-africa-logo-icon.png": "def4",
	"./rugby/stormers-logo-icon.png": "29da",
	"./rugby/tonga-logo-icon.png": "80e3",
	"./rugby/ulster-rugby-logo-icon.png": "7606",
	"./rugby/uruguay-logo-icon.png": "b343",
	"./rugby/wales-logo-icon.png": "23ef",
	"./rugby/western-province-logo-icon.png": "a5c3",
	"./rugby/zebre-parma-logo-icon.png": "5683",
	"./soccer/acmilan-logo-icon.png": "b94f",
	"./soccer/aek-athens-logo-icon.png": "52af",
	"./soccer/afc-bournemouth-logo-icon.png": "1c49",
	"./soccer/ajaccio-logo-icon.png": "d806",
	"./soccer/ajax-amsterdam-logo-icon.png": "d101",
	"./soccer/ajax-logo-icon.png": "aed4",
	"./soccer/alaves-logo-icon.png": "ee0b",
	"./soccer/albania-logo-icon.png": "0fd7",
	"./soccer/almeria-logo-icon.png": "414b",
	"./soccer/amazulu-logo-icon.png": "e01a",
	"./soccer/angers-sco-logo-icon.png": "eb63",
	"./soccer/antwerp-logo-icon.png": "1423",
	"./soccer/apollon-logo-icon.png": "af0d",
	"./soccer/argentina-logo-icon.png": "9924",
	"./soccer/aris-limassol-logo-icon.png": "0bf0",
	"./soccer/arsenal-logo-icon.png": "ee5f",
	"./soccer/aston-villa-logo-icon.png": "83e7",
	"./soccer/atalanta-logo-icon.png": "90d7",
	"./soccer/athletic-bilbao-logo-icon.png": "28e4",
	"./soccer/athletic-club-logo-icon.png": "3e79",
	"./soccer/atlanta-logo-icon.png": "0e3f",
	"./soccer/atletico-madrid-logo-icon.png": "c141",
	"./soccer/australia-logo-icon.png": "6483",
	"./soccer/austria-logo-icon.png": "a05b",
	"./soccer/auxerre-logo-icon.png": "093d",
	"./soccer/barcelona-logo-icon.png": "2313",
	"./soccer/baroka-logo-icon.png": "3fd6",
	"./soccer/bayer-leverkusen-logo-icon.png": "2e87",
	"./soccer/bayern-munchen-logo-icon.png": "545a",
	"./soccer/belgium-logo-icon.png": "9a68",
	"./soccer/benfica-logo-icon.png": "3bae",
	"./soccer/blue-bulls-logo-icon.png": "4feb",
	"./soccer/bodo-glimt-logo-icon.png": "a1bb",
	"./soccer/bologna-logo-icon.png": "b2cc",
	"./soccer/bordeaux-logo-icon.png": "f5d8",
	"./soccer/borussia-dortmund-logo-icon.png": "fc6f",
	"./soccer/brazil-logo-icon.png": "757c",
	"./soccer/brentford-logo-icon.png": "fcb1",
	"./soccer/brest-logo-icon.png": "5517",
	"./soccer/brighton-&-hove-albion-logo-icon.png": "659c",
	"./soccer/burnley-logo-icon.png": "c356",
	"./soccer/cadiz-logo-icon.png": "0a5e",
	"./soccer/cameroon-logo-icon.png": "b376",
	"./soccer/canada-logo-icon.png": "6471",
	"./soccer/cape-town-city-logo-icon.png": "e41c",
	"./soccer/cape-town-spurs-logo-icon.png": "7b7a",
	"./soccer/cardiff-rugby-logo-icon.png": "9173",
	"./soccer/celta-de-vigo-logo-icon.png": "f4c0",
	"./soccer/celta-vigo-logo-icon.png": "6743",
	"./soccer/celtic-fc-logo-icon.png": "2405",
	"./soccer/celtic-logo-icon.png": "5a8c",
	"./soccer/chelsea-logo-icon.png": "e152",
	"./soccer/china-pr-logo-icon.png": "7229",
	"./soccer/chippa-united-logo-icon.png": "3e09",
	"./soccer/clermont-logo-icon.png": "0667",
	"./soccer/club-brugge-kv-logo-icon.png": "9e04",
	"./soccer/club-brugge-logo-icon.png": "4236",
	"./soccer/colombia-logo-icon.png": "392b",
	"./soccer/costa-rica-logo-icon.png": "681f",
	"./soccer/cremonese-logo-icon.png": "b165",
	"./soccer/croatia-logo-icon.png": "a755",
	"./soccer/crvena-zvezda-logo-icon.png": "999e",
	"./soccer/crystal-palace-logo-icon.png": "6bf0",
	"./soccer/czech-republic-logo-icon.png": "ea42",
	"./soccer/denmark-logo-icon.png": "758f",
	"./soccer/deportivo-alaves-logo-icon.png": "35c9",
	"./soccer/dinamo-zagreb-logo-icon.png": "8d8fc",
	"./soccer/dynamo-kyiv-logo-icon.png": "8708",
	"./soccer/ecuador-logo-icon.png": "f57a",
	"./soccer/edinburgh-rugby-logo-icon.png": "a02c",
	"./soccer/eintracht-frankfurt-logo-icon.png": "6b23",
	"./soccer/elche-logo-icon.png": "da3f",
	"./soccer/empoli-logo-icon.png": "d817",
	"./soccer/england-logo-icon.png": "a95a",
	"./soccer/espanyol-logo-icon.png": "6dd8",
	"./soccer/everton-logo-icon.png": "5cea",
	"./soccer/ferencvaros-logo-icon.png": "c96b",
	"./soccer/feyenoord-logo-icon.png": "5410",
	"./soccer/fiorentina-logo-icon.png": "5be8",
	"./soccer/france-logo-icon.png": "ad5d",
	"./soccer/fulham-logo-icon.png": "1135",
	"./soccer/galatasaray-logo-icon.png": "3b83",
	"./soccer/georgia-logo-icon.png": "c79a",
	"./soccer/germany-logo-icon.png": "b467",
	"./soccer/getafe-logo-icon.png": "20ec",
	"./soccer/ghana-logo-icon.png": "9e4e",
	"./soccer/girona-logo-icon.png": "9b23",
	"./soccer/golden-arrows-logo-icon.png": "9df9",
	"./soccer/granada-logo-icon.png": "1026",
	"./soccer/haiti-logo-icon.png": "e887",
	"./soccer/hellas-verona-logo-icon.png": "250a",
	"./soccer/hungary-logo-icon.png": "78fa",
	"./soccer/india-logo-icon.png": "3d59",
	"./soccer/inter-milan-logo-icon.png": "f6da",
	"./soccer/internazionale-logo-icon.png": "b120",
	"./soccer/ipswich-town-logo-icon.png": "e729",
	"./soccer/iran-logo-icon.png": "9802",
	"./soccer/italy-logo-icon.png": "acdc",
	"./soccer/jamaica-logo-icon.png": "aa9b",
	"./soccer/japan-logo-icon.png": "12c7",
	"./soccer/juventus-logo-icon.png": "fe4a",
	"./soccer/kaizer-chiefs-logo-icon.png": "e074",
	"./soccer/ki-logo-icon.png": "28ca",
	"./soccer/kobenhavn-logo-icon.png": "7e42",
	"./soccer/korea-republic-logo-icon.png": "67ff",
	"./soccer/lazio-logo-icon.png": "5036",
	"./soccer/lecce-logo-icon.png": "c091",
	"./soccer/leeds-united-logo-icon.png": "fe36",
	"./soccer/leicester-city-logo-icon.png": "779b",
	"./soccer/lens-logo-icon.png": "a412",
	"./soccer/levante-logo-icon.png": "916c",
	"./soccer/lille-logo-icon.png": "ea73",
	"./soccer/liverpool-logo-icon.png": "e416",
	"./soccer/lorient-logo-icon.png": "75c7d",
	"./soccer/ludogorets-logo-icon.png": "168e",
	"./soccer/luton-town-logo-icon.png": "cccc",
	"./soccer/maccabi-haifa-logo-icon.png": "e849",
	"./soccer/mallorca-logo-icon.png": "5585",
	"./soccer/mamelodi-sundowns-logo-icon.png": "c9ea",
	"./soccer/manchester-city-logo-icon.png": "f34b",
	"./soccer/manchester-united-logo-icon.png": "cb69",
	"./soccer/maritzburg-united-logo-icon.png": "b0d6",
	"./soccer/marseilles-fc-logo-icon.png": "a738",
	"./soccer/marumo-gallants-logo-icon.png": "5594",
	"./soccer/metz-logo-icon.png": "c842",
	"./soccer/mexico-logo-icon.png": "4aed",
	"./soccer/midtylland-logo-icon.png": "1ebf",
	"./soccer/milan-logo-icon.png": "cd25",
	"./soccer/molde-logo-icon.png": "c35c",
	"./soccer/monaco-logo-icon.png": "f011",
	"./soccer/montpellier-logo-icon.png": "0e69",
	"./soccer/monza-logo-icon.png": "bd64",
	"./soccer/morocco-logo-icon.png": "9840",
	"./soccer/nambia-logo-icon.png": "2fed",
	"./soccer/nantes-logo-icon.png": "ae89",
	"./soccer/napoli-logo-icon.png": "1d67",
	"./soccer/netherlands-logo-icon.png": "a727",
	"./soccer/new-zealand-logo-icon.png": "762f",
	"./soccer/newcastle-united-logo-icon.png": "04dc",
	"./soccer/nice-logo-icon.png": "fe0b",
	"./soccer/nigeria-logo-icon.png": "4e8b",
	"./soccer/norway-logo-icon.png": "2559",
	"./soccer/norwich-logo-icon.png": "2f6d",
	"./soccer/nottingham-forest-logo-icon.png": "cfb5",
	"./soccer/olimpija-logo-icon.png": "1b20",
	"./soccer/olympique-lyonnais-logo-icon.png": "4b0d",
	"./soccer/olympique-marseille-logo-icon.png": "5733",
	"./soccer/orlando-pirates-logo-icon.png": "e422",
	"./soccer/osasuna-logo-icon.png": "4a33",
	"./soccer/ospreys-logo-icon.png": "22c5",
	"./soccer/pakistan-logo-icon.png": "2ccc",
	"./soccer/panama-logo-icon.png": "7132",
	"./soccer/panathinaikos-logo-icon.png": "2cd9",
	"./soccer/philippines-logo-icon.png": "8107",
	"./soccer/poland-logo-icon.png": "e2ad",
	"./soccer/polokwane-city-logo-icon.png": "29b7",
	"./soccer/porto-logo-icon.png": "329b",
	"./soccer/portugal-logo-icon.png": "eced",
	"./soccer/psg-logo-icon.png": "62da",
	"./soccer/psv-logo-icon.png": "027e",
	"./soccer/pumas-logo-icon.png": "8fc5",
	"./soccer/pyunik-logo-icon.png": "26dd",
	"./soccer/qarabag-fk-logo-icon.png": "f543",
	"./soccer/qarabag-logo-icon.png": "600d",
	"./soccer/qatar-logo-icon.png": "d757",
	"./soccer/rakow-czestochowa-logo-icon.png": "97c3",
	"./soccer/rangers-logo-icon.png": "a51e",
	"./soccer/rayo-vallecano-logo-icon.png": "4bb6",
	"./soccer/rb-leipzig-logo-icon.png": "0367",
	"./soccer/real-betis-logo-icon.png": "e924",
	"./soccer/real-madrid-logo-icon.png": "2dba",
	"./soccer/real-sociedad-logo-icon.png": "6026",
	"./soccer/real-valladolid-logo-icon.png": "539a",
	"./soccer/reims-logo-icon.png": "22e7",
	"./soccer/rennes-logo-icon.png": "fe04",
	"./soccer/republic-of-ireland-logo-icon.png": "36b4",
	"./soccer/richards-bay-logo-icon.png": "57dd",
	"./soccer/roma-logo-icon.png": "57e5",
	"./soccer/romania-logo-icon.png": "0c48",
	"./soccer/royal-am-logo-icon.png": "2cae",
	"./soccer/saint-etienne-logo-icon.png": "3bf2",
	"./soccer/salernitana-logo-icon.png": "4042",
	"./soccer/salzburg-logo-icon.png": "0d3f",
	"./soccer/sampdoria-logo-icon.png": "6a42",
	"./soccer/sassuolo-logo-icon.png": "c8a2",
	"./soccer/saudi-arabia-logo-icon.png": "4a52",
	"./soccer/scarlets-logo-icon.png": "a27b",
	"./soccer/scotland-logo-icon.png": "d887",
	"./soccer/sekhukhune-united-logo-icon.png": "0aba",
	"./soccer/senegal-logo-icon.png": "06b8",
	"./soccer/serbia-logo-icon.png": "4d04",
	"./soccer/servette-logo-icon.png": "3be3",
	"./soccer/sevilla-logo-icon.png": "b603",
	"./soccer/shakhtar-donetsk-logo-icon.png": "19fe",
	"./soccer/sheffield-united-logo-icon.png": "bb9d",
	"./soccer/sheriff-logo-icon.png": "5df2",
	"./soccer/slovakia-logo-icon.png": "a58a",
	"./soccer/slovan-bratislava-logo-icon.png": "3648",
	"./soccer/slovenia-logo-icon.png": "e9be",
	"./soccer/south-africa-logo-icon.png": "154d",
	"./soccer/southampton-logo-icon.png": "08b3",
	"./soccer/spain-logo-icon.png": "2c50",
	"./soccer/sparta-praha-logo-icon.png": "989c",
	"./soccer/spezia-logo-icon.png": "17d8",
	"./soccer/sporting-braga-logo-icon.png": "0294",
	"./soccer/sporting-cp-logo-icon.png": "188c",
	"./soccer/stade-brestois-logo-icon.png": "314f",
	"./soccer/stellenbosch-logo-icon.png": "244a",
	"./soccer/strasbourg-logo-icon.png": "a9a1",
	"./soccer/sturm-graz-logo-icon.png": "a4ed",
	"./soccer/sunderland-logo-icon.png": "ee5b",
	"./soccer/supersport-united-logo-icon.png": "492f",
	"./soccer/swallows-logo-icon.png": "22f5",
	"./soccer/sweden-logo-icon.png": "baaa",
	"./soccer/switzerland-logo-icon.png": "6da0",
	"./soccer/torino-logo-icon.png": "aa6f",
	"./soccer/tottenham-hotspur-logo-icon.png": "7cf1",
	"./soccer/toulouse-logo-icon.png": "ec84",
	"./soccer/trabzonspor-logo-icon.png": "a8f1",
	"./soccer/troyes-logo-icon.png": "8e54",
	"./soccer/ts-galaxy-logo-icon.png": "9d93",
	"./soccer/tsc-logo-icon.png": "4fcc",
	"./soccer/ttm-logo-icon.png": "4705",
	"./soccer/tunisia-logo-icon.png": "03d2",
	"./soccer/turkey-logo-icon.png": "d66b",
	"./soccer/uae-logo-icon.png": "1149",
	"./soccer/udinese-logo-icon.png": "af0a",
	"./soccer/ukraine-logo-icon.png": "06ac",
	"./soccer/union-berlin-logo-icon.png": "e282",
	"./soccer/union-saint-gilloise-logo-icon.png": "1eaa",
	"./soccer/united-states-logo-icon.png": "4c4f",
	"./soccer/uruguay-logo-icon.png": "1392",
	"./soccer/valencia-logo-icon.png": "80c8",
	"./soccer/vietnam-logo-icon.png": "e34f",
	"./soccer/viktoria-plzen-logo-icon.png": "687b",
	"./soccer/villarreal-logo-icon.png": "82bb",
	"./soccer/wales-logo-icon.png": "9e76",
	"./soccer/west-ham-united-logo-icon.png": "5890",
	"./soccer/west-indies-logo-icon.png": "96e6",
	"./soccer/wolverhampton-wanderers-logo-icon.png": "ee99",
	"./soccer/young-boys-logo-icon.png": "1f30",
	"./soccer/zalgiris-logo-icon.png": "d1db",
	"./soccer/zambia-logo-icon.png": "068f",
	"./soccer/zimbabwe-logo-icon.png": "df94"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "11fb";